const bannerHalf = {
    BannerHalf: {
        baseStyle: () => ({
            container: {
                gridColumn: '1 / -1',
                flexWrap: {base: 'nowrap', md: 'wrap'},
                flexDirection: {base: 'column', md: 'row'},
                maxW: {base: '100vw', md: 'none'},
            },
            productsGrid: {
                columnGap: 'space.gap.horizontal.grid3.md',
                rowGap: 'space.padding.vertical.3xl',
                flex: {base: '1', md: '1 0 0'},
                w: {base: '100%', md: 'auto'},
            },
            moduleWrapper: {
                flex: {base: '1', md: '1 0 0'},
                h: '100%',
                w: '100%',
            },
        }),
        variants: {
            grid2: {
                container: {
                    gap: {base: 'spacing.8', md: 'spacing.4'},
                },
                productsGrid: {
                    gridTemplateColumns: {base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)'},
                    columnGap: {base: 'space.gap.horizontal.grid2.base', sm: 'space.gap.horizontal.grid2.sm'},
                },
            },
            grid3: {
                container: {
                    gap: {base: 'spacing.8', md: 'spacing.4'},
                },
                productsGrid: {
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    columnGap: {base: 'space.gap.horizontal.grid3.base', md: 'space.gap.horizontal.grid3.md'},
                },
            },
        },
    },
}

export default bannerHalf
